import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
// Redux
import { useRegisterMutation } from "../../redux/api/authApi";
import { useSelector } from "react-redux";

const Register = () => {
  const navigate = useNavigate();
  const [register, { isLoading, error}] = useRegisterMutation();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const [user, setUser] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
    website: "",
    CompanyName: "",
  });

  const { name, email, password , phone, website, CompanyName} = user;
   
  const onChange = (e) => {
  setUser({ ...user, [e.target.name]: e.target.value });
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    const signUpData = {
      name,
      email,
      password,
      phone,
      website,
      CompanyName,
        };
  await register(signUpData);
  } 

  useEffect(() => {
    if (isAuthenticated) {
      toast.success("Registration Successful");
      navigate("/");
    }

    if (error) {     
      toast.error(error?.data?.message);
    }  
  }, [error, isAuthenticated, navigate]);
                

  return (
    <div className="flex flex-wrap signup-login-page-content">
      <div className="w-full md:w-1/2 px-4">
        <div className="mx-auto signup-image-section">
          <img
            src="../img/sign_up.png"
            alt="Signup"
            loading="lazy"
            className="max-w-full h-auto"
          />
        </div>
      </div>

      <div className="w-full md:w-1/2 px-4">
        <section className="login-signup-section signup-section">
          <form name="accounts_signup_form" onSubmit={submitHandler}>
            <Link to="/">
              <Image
                src="../img/new_logo_grey.png"
                alt="Creatyea Technology"
                className="logo"
              />
            </Link>
            <span className="block mt-2">
              Hello there! Sign up and start managing your orders
            </span>
            <div className="mb-3 w-full">
              <label
                htmlFor="name_field"
                className="block text-gray-700 text-sm font-bold mb-2"
              >
                Full Name
              </label>
              <input
                type="text"
                id="name_field"
                className="shadow appearance-none border rounded w-full py-2 px-12 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                name="name"
                value={name}
                onChange={onChange}
                placeholder="Enter your full name"
              />
            </div>
            <div className="mb-3 w-full">
              <label
                htmlFor="email_field"
                className="block text-gray-700 text-sm font-bold mb-2"
              >
                Email
              </label>
              <input
                type="email"
                id="email_field"
                className="shadow appearance-none border rounded w-full py-2 px-12 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                name="email"
                value={email}
                onChange={onChange}
                placeholder="Enter your email"
              />
            </div>
            <div className="mb-3 w-full">
              <label
                htmlFor="password"
                className="block text-gray-700 text-sm font-bold mb-2"
              >
                Password
              </label>
              <input
                type="password"
                name="password"
                id="password"
                value={password}
                onChange={onChange}
                className="shadow appearance-none border rounded w-full py-2 px-12 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Enter your password"
              />
            </div>
            <div className="mb-3 w-full">
              <label
                htmlFor="phone"
                className="block text-gray-700 text-sm font-bold mb-2"
              >
                PhoneNumber
              </label>
              <input
                type="text"
                name="phone"
                id="phone"
                value={phone}
                onChange={onChange}
                className="shadow appearance-none border rounded w-full py-2 px-12 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="E g.+212 0123456789"
              />
            </div>
            <div className="mb-3 w-full">
              <label
                htmlFor="website"
                className="block text-gray-700 text-sm font-bold mb-2"
              >
                Website
              </label>
              <input
                type="text"
                name="website"
                id="website"
                value={website}
                onChange={onChange}
                className="shadow appearance-none border rounded w-full py-2 px-12 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="E g.creatyea.com"
              />
            </div>
            <div className="mb-3 w-full">
              <label
                htmlFor="CompanyName"
                className="block text-gray-700 text-sm font-bold mb-2"
              >
                CompanyName
              </label>
              <input
                type="text"
                name="CompanyName"
                id="CompanyName"
                value={CompanyName}
                onChange={onChange}
                className="shadow appearance-none border rounded w-full py-2 px-12 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="E g. Creatyea Technology"
              />
            </div>

            <button
              type="submit"
              className={`mt-4 w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
                isLoading ? "bg-gray-400" : "bg-blue-600 hover:bg-blue-700"
              } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`}
              disabled={isLoading}
            >
              {isLoading ? (
                <i className="fas fa-spinner fa-spin"></i>
              ) : (
                "Sign Up"
              )}
            </button>
          </form>
        </section>

        <section className="social-media-login-section mt-10">
          {/* Social media login options could go here */}
        </section>
        <section className="simple-section mt-4">
          <span className="block">Already have an account?</span>
          <Link to="/login" className="text-blue-600 hover:text-blue-700">
            Back to Login
          </Link>
        </section>
      </div>
      <footer className="w-full customer-login-footer mt-4 px-4 py-2">
        <Link
          to="/privacy_policy"
          className="text-blue-600 hover:text-blue-700"
        >
          Privacy Policy
        </Link>
        <Link
          to="/terms_conditions"
          className="ml-4 text-blue-600 hover:text-blue-700"
        >
          Terms & Conditions
        </Link>
      </footer>
    </div>
  );
};

export default Register;
